<!--
 * @Author: Niklaus
 * @Date: 2025-08-14 17:20:22
 * @LastEditTime: 2026-04-24 17:16:48
 * @LastEditors: Niklaus
 * @Description: 实收费用明细
-->
<template>
    <basic-container isCard :body-style="{ padding: '0', height: '100%' }" class="h-100p">
        <el-form :inline="true" :model="formInline" size="small" class="demo-form-inline">
            <el-form-item label="所属楼宇" label-width="80px">
                <model-search-select class="dis-b" model="wp_building" valueKey="name"
                    v-model="formInline.ssly"></model-search-select>
            </el-form-item>
            <el-form-item label="企业名称" label-width="80px">
                <el-input v-model="formInline.subject" />
            </el-form-item>
            <el-form-item label="缴费时间">
                <el-date-picker class="w-150" v-model="formInline.startDate" placeholder="开始日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="-" width="300px">
                <el-date-picker class="w-150" v-model="formInline.endDate" placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item>

            </el-form-item>
        </el-form>
        <div class="h-100p">
            <avue-crud :option="option" :table-loading="loading" :data="data" ref="crud" :page.sync="page"
                @on-load="onLoad" class="custom">

                <template slot="menuLeft">
                    <el-button type="primary" @click="getTime('LW')">上周实收</el-button>
                    <el-button type="primary" @click="getTime('W')">本周实收</el-button>
                    <el-button type="primary" @click="getTime('M')">本月实收</el-button>
                    <el-button type="primary" @click="getTime('Y')">本年度实收</el-button>
                    <el-button type="primary" @click="onLoad">查询</el-button>
                    <el-button type="primary" @click="exportData">导出</el-button>
                </template>
            </avue-crud>

        </div>
    </basic-container>
</template>
<script>
import dayjs, { Dayjs } from "dayjs"
import { getWeek } from '@/util/date'
import { getMetaCommonList, getMetaListUrl, getMetaCommonListExport } from '@/api/busiMode/metaCommon';
export default {
    data() {
        return {
            loading: true,
            page: {
                size: 10,
                current: 1,
                total: 0,
            },
            formInline: {
                startDate: "",
                endDate: "",
                ssly: '',
                subject: '',
            },
            option: {
                dateBtn: false,
                border: true,
                height: 'auto',
                tip: true,
                searchShowBtn: false,
                searchMenu: false,
                searchShow: false,
                addBtn: false,
                refreshBtn: false,
                addRowBtn: false,
                columnBtn: false,
                rowKey: '',
                showPage: true,
                index: true,
                indexLabel: '序号',
                selection: false,
                showHeader: true,
                expand: false,
                highlightCurrentRow: true,
                stripe: false,
                menu: false,
                column: [
                    {
                        align: 'left',
                        label: '所属楼宇',
                        prop: 'ssly',
                        width: 150,
                    },
                    {
                        align: 'left',
                        label: '企业名称',
                        prop: 'subject',
                        width: 180,
                    },
                    {
                        align: 'left',
                        label: '合同编号',
                        prop: 'contract_code',
                        width: 220,
                    },

                    {
                        align: 'left',
                        label: '账单编号',
                        prop: 'receipt_no',
                        overHidden: true,
                        width: 100,
                    },
                    {
                        align: 'left',
                        label: '应收金额',
                        prop: 'amount_receivable',
                        width: 110,
                    },
                    {
                        align: 'left',
                        label: '实收金额',
                        prop: 'amount_received',
                        width: 110,
                    },
                    {
                        align: 'left',
                        label: '减免金额',
                        prop: 'redu_amount_received',
                        width: 100,
                    },
                    {
                        align: 'left',
                        label: '账单开始时间',
                        prop: 'period_start_time',
                        width: 150
                    },
                    {
                        align: 'left',
                        label: '账单结束时间',
                        prop: 'period_end_time',
                        width: 150
                    },

                    {
                        label: "缴费时间",
                        prop: "success_time",
                        showColumn: true,
                        type: "date",
                        width: 150
                    },

                ],
            },
            model: 'wisdom_park.v_rpt_buil_cont_rece_paym_curyear',
            data: [],
        };
    },

    props: {
        type: {
            type: String,
            default: ''
        }
    },

    created() {
        if (this.type) {
            this.getTime(this.type)
        }
    },
    methods: {
        /**
         * @Author: Niklaus
         * @Description: 获取列表数据
         */
        onLoad() {
            this.loading = true;
            let body = {
                current: this.page.currentPage || 1,
                size: this.page.pageSize || 10,
                orders: [{ field: "success_time", sort: "DESC" }],
                wheres: this.autoUpdateWheres()
            };
            getMetaCommonList(this.model, body).then(res => {
                const data = res.data.data;
                this.page.total = data.total;
                this.data = data.records;
                this.loading = false;
            });
        },
        /**
         * @Author: Niklaus
         * @Description: 导出数据
         */
        exportData() {
            this.downLoading = true
            let body = {
                current: 1,
                size: 100,
                orders: [{ field: "success_time", sort: "DESC" }],
                wheres: this.autoUpdateWheres()
            };

            getMetaCommonListExport(this.model, body).then((res) => {
                console.log('---------账单明细导出数据-------')
                console.log(res)
                this.downLoading = false
                let url = window.URL.createObjectURL(new Blob([res.data]))
                let a = document.createElement("a")
                a.style.display = "none"
                a.href = url
                a.download = "实收明细导出数据.xlsx"
                document.body.appendChild(a)
                a.click()
            })
        },

        /**
         * @Author: Niklaus
         * @Description: 获取指定类型的时间段并查询数据
         * @param {*} type 类型
         */
        getTime(type) {
            if (type == 'LW') {
                let t = getWeek(-1, -2, -2)
                if (t && t.length > 0) {
                    this.formInline.startDate = t[0]
                    this.formInline.endDate = t[1]
                }
            } else if (type == 'W') {
                let t = getWeek(0)
                if (t && t.length > 0) {
                    this.formInline.startDate = t[0]
                    this.formInline.endDate = t[1]
                }
            } else if (type == 'M') {
                this.formInline.startDate = dayjs().startOf('month').format('YYYY-MM-DD')
                this.formInline.endDate = dayjs().endOf('month').format('YYYY-MM-DD')
            } else if (type == 'Y') {
                let y = dayjs().year()
                this.formInline.startDate = y + '-01-01'
                this.formInline.endDate = y + '-12-31'
            }
            this.page.current = 1
            this.onLoad()
        },

        autoUpdateWheres() {
            let wheres = []
            console.log(this.formInline)
            Object.keys(this.formInline).forEach(key => {
                if (this.formInline[key]) {
                    if (key.includes('Date')) {
                        if (key == 'startDate') {
                            wheres.push({ field: 'success_time', op: 'GE', value: this.formInline[key] })
                        } else if (key == 'endDate') {
                            wheres.push({ field: 'success_time', op: 'LE', value: this.formInline[key] })
                        }
                    } else {
                        wheres.push({ field: key, op: 'LIKE', value: this.formInline[key] })

                    }
                }
            })
            return wheres
        }
    },
}
</script>
<style lang="scss" scoped>
.custom .avue-crud__menu {
    display: none !important;
    height: 0;
    min-height: 0;
}

.demo-form-inline {
    padding: 20px 15px 0 20px;
}
</style>
